import { render, staticRenderFns } from "./HappinessReportsCard.vue?vue&type=template&id=2ae22f4c&"
import script from "./HappinessReportsCard.vue?vue&type=script&lang=js&"
export * from "./HappinessReportsCard.vue?vue&type=script&lang=js&"
import style0 from "./HappinessReportsCard.vue?vue&type=style&index=0&id=2ae22f4c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports